import React from 'react';

import { CmBox, CmFlex } from '@/components/uiParts';

export const LoginLayout: React.FC = ({ children }) => {
  return (
    <CmFlex
      direction="column"
      justify="center"
      align="center"
      minHeight="100%"
      bg="bgGray"
    >
      <CmBox width={{ base: '90%', md: '70%', lg: '50%' }} py={10}>
        {children}
      </CmBox>
    </CmFlex>
  );
};
